import React from "react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import * as analytics from "@/services/analytics";

analytics.init();

interface Props {
  children: React.ReactNode;
}

export const CSPostHogProvider: React.FC<Props> = ({ children }) => (
  <PostHogProvider client={posthog}>{children}</PostHogProvider>
);
